/**
 * Axial coordinates for hex grid (q, r)
 * Uses pointy-top orientation
 */
export interface AxialCoord {
  q: number;
  r: number;
}

/**
 * Cube coordinates for hex grid (q, r, s) where q + r + s = 0
 * Useful for distance calculations and line drawing
 */
export interface CubeCoord {
  q: number;
  r: number;
  s: number;
}

/**
 * Pixel/world position
 */
export interface PixelCoord {
  x: number;
  y: number;
}

/**
 * Hex tile data
 */
export interface HexTile {
  coord: AxialCoord;
  owner: PlayerSide | null;
  occupant: string | null; // Entity ID
}

/**
 * Player sides in the game
 */
export enum PlayerSide {
  Player1 = 1,
  Player2 = 2,
}

/**
 * Direction for pointy-top hex (6 neighbors)
 */
export enum HexDirection {
  NorthEast = 0,
  East = 1,
  SouthEast = 2,
  SouthWest = 3,
  West = 4,
  NorthWest = 5,
}

/**
 * Grid dimensions configuration
 */
export interface GridConfig {
  width: number;
  height: number;
  hexSize: number;
  origin: PixelCoord;
}
